import React from "react";
import { Switch, Route, BrowserRouter, } from "react-router-dom";
import Login from "./page/login/login";
import RouterPage from "./page/router_page";
import LandingPage from "./page/landing/landing-page";
import SignUpPage from "./page/login/sign_up";
import Salir from "./page/salir";
// import DashboardPage from "./page/dashboard";
import RegisterPage from "./page/landing/register-page";
import ProfilePage from "./page/public/profile_page";
import DetalleProductoPage from "./page/public/detalle-producto";

const RouterMain = () => {
  // const { path } = useRouteMatch();
  // console.log('RouterMain');
  // console.log(path);
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/landing">
          <LandingPage />
        </Route>
        {/* <Route exact path="/product/:id">
          <DetalleProducto />
        </Route> */}
        <Route exact path="/register-page">
          <RegisterPage />
        </Route>
        <Route exact path="/login">
          <Login />
        </Route>
        <Route exact path="/profile">
          <ProfilePage />
        </Route>
        <Route exact path="/detalle-producto/:id">
          <DetalleProductoPage />
        </Route>
        <Route exact path="/sign-up">
          <SignUpPage />
        </Route>
        <Route exact path="/salir">
          <Salir />
        </Route>
        <Route path="/">
          <RouterPage />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default RouterMain;
